import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css';
import { momentHelper } from '../../report/helpers'

const DEFAULT_ROW = 20+1
class PrintReportAnalysisDeliveryEfficiency extends Component {

    constructor(...args) {
        super(...args)
        
        this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

        var cssPagedMedia = (function() {
            var style = document.createElement('style');
            document.head.appendChild(style);
            return function (rule) {
                style.innerHTML = rule;
            };
        }());
  
        cssPagedMedia.size = function(size) {
            cssPagedMedia('@page {size: ' + size + '}');
        };
        cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange==='false'&&this.props.year!==undefined&&this.props.month!==undefined&&this.props.day!==undefined) {
            ReportStore.loadAnalysisDeliveryEfficiency(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange==='true'&&this.props.startDate!==undefined&&this.props.endDate!==undefined) {
            ReportStore.loadAnalysisDeliveryEfficiencyRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getDate() {
        let {day,year,month,isRange,startDate,endDate} = this.props
        if (isRange==='true') {
            let start = startDate
            let end = endDate
            return 'ประจำวันที่ '+start+' - '+end
        } else {
            let text = 'ประจำวันที่ '
            text += day+' '+momentHelper.getMonthText(month)+' '+(year-543)
            if (year==='0'||year==='00'||year===0) {
                text = 'ทั้งหมด'
            } else if (month==='0'||month==='00'||month===0) {
                text = 'ประจำปี '+(year-543)
            } else if (day==='0'||day==='00'||day===0) {
                text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+(year-543)
            }
            return text
        }  
    }

    renderRowData(data,indexs,length) {
        if (data.length===0) {
            return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item,index)=>{
                    let number = 1    
                    if (indexs===0)
                        number += index
                    else {
                        number += (indexs*(DEFAULT_ROW-1))+index
                    }
                    return(
                        <tr key={index}>
                            <td className='text-center' style={{verticalAlign:'middle'}}>{number}</td>
                            <td className='text-center' style={{verticalAlign:'middle'}}><button className={"btn-dl-ef-normal "+item.color} /></td>
                            <td className='text-center' style={{verticalAlign:'middle'}}>{item.count}</td>
                        </tr>
                    )
                })
            )
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-product-balance'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'80px'}}>ประสิทธิภาพการจัดส่ง</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวน</td>
                    </tr>
                    {this.renderRowData(item,index,length)}
                    <tr>
                        <td colSpan={2} className='text-right'>รวมทั้งหมด</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('count'))}</td>
                    </tr>  
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print print-report-analsis-inout-work' key={index}>
                <header className="text-center">
                    <h2>ตารางรายงานประสิทธิภาพในการส่งมอบรถ</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
            newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportAnalysisDeliveryEfficiency.defaultProps = {
    title: 'ตารางรายงานประสิทธิภาพในการส่งมอบรถ',  
    mode: '',
    workNo: ''
}
export default PrintReportAnalysisDeliveryEfficiency;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportAnalysisDeliveryEfficiency.js